export default "__VITE_ASSET__a6653f35__"